import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_TASK_CREATE } from "./gql";

const useTaskCreate = createDefaultMutationHook(STACK_TASK_CREATE);
export const useBulkTaskCreate = createBulkMutationHook(STACK_TASK_CREATE);

export default useTaskCreate;
